import styled from "styled-components";

export const PanelSimpleEditorContainer = styled.div`
  display: grid;
  place-content: center;
  width: 100%;
  height: 100%;
`;

export const PanelSimpleContainer = styled.div`
  width: 80%;
  margin: 0 auto;
  margin-top: 10%;
`;
